import { gql } from "apollo-boost"

export const getAllAssitants = gql`
query Assistants($lastRow: Float!, $pageSize: Float!) {
  CensusAssistants(lastRow: $lastRow, pageSize: $pageSize) {
    assistants {
      id
      folio
      name
      lastName
      maidenName
      gender
      birthdate
      curp
      phone
      state
      municipality
      colony
      type
      submission {
        id
        issueDescription
        strategicAxis
        specificObjectives{
        id
        activities {
          id
          }
        }  
      }
    }
  }
}
`